import React, { useMemo } from "react";
import { Link } from "react-router-dom";

import { useRoleClientSelection } from "../contexts/RoleClientSelectionContext";
import { resolveRoute } from "../utils/routeHelpers";

export default function RoleClientLink({ to, children, ...rest }) {
  const { selectedRole, selectedClient } = useRoleClientSelection();

  const resolver = useMemo(() => {
    return (route) =>
      resolveRoute(route, {
        role: selectedRole,
        client: selectedClient,
      });
  }, [selectedRole, selectedClient]);
  return (
    <Link to={resolver(to)} {...rest}>
      {children}
    </Link>
  );
}
